// MemberTable.jsx
import React, { useEffect, useState } from "react";
import axios from "axios";
import "./AppHome.css";
import "../Admin/Admin.css";
import Header from "../Home/Header";
import DialogBox from "../Home/DialogBox";
import { MdEdit, MdDelete, MdClose } from "react-icons/md";
import { useNavigate } from "react-router-dom";

function MemberTable() {
  const [members, setMembers] = useState([]);
  const [membershipTypes, setMembershipTypes] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedBranchCode, setSelectedBranchCode] = useState("");

  const [editForm, setEditForm] = useState({});
  const [modalMessage, setModalMessage] = useState({ type: "", text: "" });


  const [dialog, setDialog] = useState({
    show: false,
    type: "",
    message: "",
    onConfirm: null,
  });

  const navigate = useNavigate();

    useEffect(() => {
                const role = sessionStorage.getItem("userRole");
                if (!role) navigate("/");
              }, [navigate]);

  // Load members + membership types
useEffect(() => {
  fetchMembers();
  fetchMembershipTypes();
}, []);

  // 🔹 Fetch membership types
const fetchMembershipTypes = async (branchCode) => {
  try {
    const res = await axios.get(
      "https://gym-invoice-back.onrender.com/api/memberships"
    );

    const allMembershipTypes = res.data || [];

    // Filter membership types according to member branch
    const filteredMembershipTypes = allMembershipTypes.filter(
      (type) =>
        type.branchCode &&
        branchCode &&
        type.branchCode.toUpperCase() === branchCode.toUpperCase()
    );

    setMembershipTypes(filteredMembershipTypes);
  } catch (err) {
    console.error("Error fetching membership types:", err);
    setMembershipTypes([]);
  }
};

  // 🔹 Fetch members (basic list)
const fetchMembers = async () => {
  try {
    const res = await axios.get(
      "https://gym-invoice-back.onrender.com/api/members"
    );

    const filtered = (res.data || []).filter(
      (m) =>
        (!m.membershipStatus ||
          m.membershipStatus.trim() === "") &&
        (!selectedBranchCode ||
          m.branchCode === selectedBranchCode)
    );

    const sorted = filtered.sort((a, b) => {
      const idA =
        parseInt((a.memberId || "").replace(/\D/g, "")) || 0;

      const idB =
        parseInt((b.memberId || "").replace(/\D/g, "")) || 0;

      return idB - idA;
    });

    setMembers(sorted);

  } catch (err) {
    console.error("Error fetching members:", err);
    setMembers([]);
  }
};

  // 🔹 Open modal to edit a member
const handleEditClick = async (member) => {
  const normalizedJoined =
    member.joinedDate && member.joinedDate.substring
      ? member.joinedDate.substring(0, 10)
      : member.joinedDate || "";

  setEditingId(member.id || member._id);

  setEditForm({
    ...member,
    joinedDate: normalizedJoined,
    regFee: member.regFee || 2000,
    regStatus: member.regStatus || "Paid",
  });

  // Fetch membership types only for this member's branch
  if (member.branchCode) {
    await fetchMembershipTypes(member.branchCode);
  } else {
    setMembershipTypes([]);
  }

  setModalMessage({ type: "", text: "" });
  setShowModal(true);
};

  // 🔹 Input change handler
  const handleEditChange = (e) => {
    const { name, value } = e.target;

    // Format date
    if (name === "joinedDate") {
      const trimmed = value ? value.substring(0, 10) : "";
      setEditForm((prev) => ({ ...prev, joinedDate: trimmed }));
      return;
    }

    // If membershipType changes, update regFee automatically if backend requires
 if (name === "membershipType") {
   setEditForm((prev) => ({
     ...prev,
     membershipType: value,
     regFee: 2000,   // always default registration fee
   }));
   return;
 }


    setEditForm((prev) => ({ ...prev, [name]: value }));
  };

  // 🔹 Update member
  const handleUpdate = async () => {
    // Basic validations
    if (!editForm.membershipStatus || !editForm.membershipType || !editForm.joinedDate) {
      setModalMessage({
        type: "warning",
        text: "⚠️ Membership Status, Type, and Joined Date are required.",
      });
      return;
    }

if (editForm.regFee === "" || editForm.regFee === null || editForm.regFee < 0) {
  setModalMessage({
    type: "warning",
    text: "⚠️ Please enter a valid Registration Fee (0 or more).",
  });
  return;
}


    if (!editForm.regStatus || editForm.regStatus.trim() === "") {
      setModalMessage({
        type: "warning",
        text: "⚠️ Please select Registration Status.",
      });
      return;
    }

    try {
      // Update backend
      const res = await axios.put(
        `https://gym-invoice-back.onrender.com/api/members/${editingId}`,
        editForm
      );

      const updatedMember = res.data;

      setDialog({
        show: true,
        type: "success",
        message: "✅ Member updated successfully!",
      });

      // If member is ACTIVATED → Move to welcome page
   if (updatedMember?.membershipStatus === "ACTIVE") {
     navigate(`/welcome/${updatedMember.memberId}`, {
       state: {
         memberName: updatedMember.name,
         membershipType: updatedMember.membershipType,
         joinedDate: updatedMember.joinedDate,
       },
     });
     return;
   }


      // Reset modal + refresh list
      setShowModal(false);
      setEditForm({});
      setEditingId(null);
      fetchMembers();
    } catch (err) {
      console.error("Update failed:", err);
      setModalMessage({
        type: "error",
        text: "❌ Failed to update member.",
      });
    }
  };

  return (
    <div className="dashboard">
      <Header />

      <div className="payment-container">
        <h2>📝 Member Activation</h2>

       <div className="branch-filter-container">
                <label>
                  <strong>Branch Code:</strong>
                </label>

                <select
                  value={selectedBranchCode}
                  onChange={(e) => {
                    setSelectedBranchCode(e.target.value);
                  }}
                >
                  <option value="">All Branches</option>
                  <option value="WB">Werahera Branch</option>
                  <option value="KB">Kesbewa Branch</option>
                </select>

                <button
                  type="button"
                  className="pay-button"
                  onClick={fetchMembers}
                >
                  🔍 Filter
                </button>


              </div>

        {/* MEMBER TABLE */}
        <table className="payment-table">
          <thead>
            <tr>
              <th>Member ID</th>
              <th>Full Name</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {members.length === 0 ? (
              <tr>
                <td colSpan="3" style={{ textAlign: "center", padding: "15px" }}>
                  No members found.
                </td>
              </tr>
            ) : (
              members.map((m) => (
                <tr key={m.id || m._id}>
                  <td>{m.memberId}</td>
                  <td>{m.name}</td>
                  <td>
                    <div className="table-action-buttons">
                      <button onClick={() => handleEditClick(m)} className="action-btn edit-btn">
                        <MdEdit size={18} /> Edit
                      </button>

                      <button
                        className="action-btn delete-btn"
                        onClick={() =>
                          setDialog({
                            show: true,
                            type: "confirm",
                            message: "⚠️ Delete this member?",
                            onConfirm: async () => {
                              try {
                                await axios.delete(
                                  `https://gym-invoice-back.onrender.com/api/members/${m.id || m._id}`
                                );
                                fetchMembers();
                                setDialog({
                                  show: true,
                                  type: "success",
                                  message: "✅ Member deleted.",
                                });
                              } catch {
                                setDialog({
                                  show: true,
                                  type: "error",
                                  message: "❌ Delete failed.",
                                });
                              }
                            },
                          })
                        }
                      >
                        <MdDelete size={18} /> Delete
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>

        {/* EDIT MODAL */}
        {editingId && showModal && (
          <div className="modal1">
            <div className="modal1-content">
              <button
                className="modal-close-btn"
                onClick={() => {
                  setShowModal(false);
                  setEditingId(null);
                  setModalMessage({ type: "", text: "" });
                }}
              >
                <MdClose />
              </button>

              <div className="payment-card">
                <h4>Activate / Edit Member</h4>

                {modalMessage.text && (
                  <div className={`modal-message ${modalMessage.type}`}>
                    {modalMessage.text}
                  </div>
                )}

                <div className="modal1-grid">
                  <div className="form-row">
                    <label>Member ID</label>
                    <input value={editForm.memberId || ""} readOnly />
                  </div>

                  <div className="form-row">
                    <label>Full Name</label>
                    <input
                      name="name"
                      value={editForm.name || ""}
                      onChange={handleEditChange}
                    />
                  </div>

                  <div className="form-row">
                    <label>Membership Status</label>
                    <select
                      name="membershipStatus"
                      value={editForm.membershipStatus || ""}
                      onChange={handleEditChange}
                    >
                      <option value="">-- Select Status --</option>
                      <option value="ACTIVE">Active</option>
                      <option value="INACTIVE">Inactive</option>
                    </select>
                  </div>

                  <div className="form-row">
                    <label>Membership Type</label>
                    <select
                      name="membershipType"
                      value={editForm.membershipType || ""}
                      onChange={handleEditChange}
                    >
                      <option value="">Select Membership Type</option>
                      {membershipTypes.map((type) => (
                        <option key={type._id} value={type.type}>
                          {type.type}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="form-row">
                    <label>Joined Date</label>
                    <input
                      type="date"
                      name="joinedDate"
                      value={editForm.joinedDate || ""}
                      onChange={handleEditChange}
                    />
                  </div>

                  <div className="form-row">
                    <label>Registration Fee</label>
                    <input
                      type="number"
                      name="regFee"
                      value={editForm.regFee || ""}
                      onChange={handleEditChange}
                    />
                  </div>

                  <div className="form-row">
                    <label>Registration Status</label>
                    <select
                      name="regStatus"
                      value={editForm.regStatus || ""}
                      onChange={handleEditChange}
                    >
                      <option value="">-- Select Status --</option>
                      <option value="Paid">Paid</option>
                      <option value="NotApplicable">Not Applicable</option>
                    </select>
                  </div>
                </div>

                <div className="filter-buttons">
                  <button onClick={handleUpdate} className="pay-button">
                    Save
                  </button>
                  <button
                    onClick={() => {
                      setShowModal(false);
                      setEditingId(null);
                      setModalMessage({ type: "", text: "" });
                    }}
                    className="pay-button"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        <DialogBox dialog={dialog} setDialog={setDialog} />
      </div>
    </div>
  );
}

export default MemberTable;
